/* tslint:disable */

import { ConcreteFragment } from "relay-runtime";
export type TradeStatus = "confirmed" | "delivered" | "pending" | "rejected" | "%future added value";
export type PendingTradeRow_trade$ref = any;
export type PendingTradeRow_trade = {
    readonly id: string;
    readonly refNumber: string | null;
    readonly tradeTimestamp: any;
    readonly company: {
        readonly id: string;
        readonly runningBalance: number;
        readonly tradeLimit: {
            readonly limit: number;
        };
        readonly info: {
            readonly name: string;
        };
    };
    readonly createdBy: {
        readonly id: string;
        readonly displayName: string | null;
    };
    readonly status: TradeStatus;
    readonly weight: number;
    readonly usdPerTroyOunce: number;
    readonly zarToUsd: number;
    readonly zarPerGram: number;
    readonly requestedZarPerGram: number;
    readonly notes: string | null;
    readonly " $refType": PendingTradeRow_trade$ref;
};



const node: ConcreteFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PendingTradeRow_trade",
  "type": "Trade",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "refNumber",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "tradeTimestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "company",
      "storageKey": null,
      "args": null,
      "concreteType": "Company",
      "plural": false,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "runningBalance",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeLimit",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanyTradeLimit",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "limit",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "info",
          "storageKey": null,
          "args": null,
          "concreteType": "CompanyInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "createdBy",
      "storageKey": null,
      "args": null,
      "concreteType": "AuditUser",
      "plural": false,
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "weight",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "usdPerTroyOunce",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "zarToUsd",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "zarPerGram",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "requestedZarPerGram",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "notes",
      "args": null,
      "storageKey": null
    }
  ]
};
})();
(node as any).hash = '60b50e90640db4fcc353102c2beb6c2b';
export default node;
